import React from 'react'

const policy = () => {
  return (
    <div className='container'>In 2017, the Supreme Court of India pronounced a landmark 
    judgment declaring the right to privacy as a fundamental right under 
    the framework of the right to life (Article 21) as per our Constitution. 
    However, a standalone and comprehensive privacy law does not exist in India. Currently, 
    the Information Technology Act 2000 read with supplementary Rules, acts as the legal cornerstone 
    to ensure the protection of personal information.
    Lawmakers and regulators progressively recognize the importance of data for 
    economic and technological growth. Hence, 2021 witnessed key developments in the data 
    privacy and personal data protection space across various sectors.
    In terms of legislation, the Joint Parliamentary Committee's report on the proposed data 
    protection law has given the Data Protection Bill of 2021 a new tone and tenure. The Reserve 
    Bank of India developed restrictions for payment aggregators and lending applications, while the 
    Bureau of Indian Guidelines formulated data privacy standards as an assurance framework for 
    enterprises. The central government also pushed out due-diligence rules for internet 
    intermediaries to regulate.
    </div>
  )
}

export default policy